import get from 'lodash.get'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { notifyStoryStarted, notifyStoryEnded, updateContextStates, clearReaderManagerLogs } from './ReaderManagerSlice'
import useReaderManagerLogs from './hooks/useReaderManagerLogs'

// This component is used to manage the events that are triggered during the reading process.
export default function ReaderManagerEvents(props) {

    const { readingMode, currentStoryId, currentWord, currentPhrase, currentAccuracy, minTimeElapsed, currentStory, currentWordsCorrect, phraseEnded } = props

    const dispatch = useDispatch()

    // For updating reader manager context states used in various modules.
    useEffect(() => {

        dispatch(updateContextStates({
            readingMode,
            currentWord,
            currentPhrase,
            currentAccuracy,
            currentStory,
            currentStoryId,
            currentWordsCorrect,
            minTimeElapsed,
            phraseEnded,
        }))

    }, [props])

    // For background noise detection used in Ready module's ASR check.
    const { detections } = props;
    useEffect(() => {

        if(detections && detections.length){
            const backgroundNoiseDetector = detections.find( detector => detector && detector.detector === 'background_noise_detector_v2')
            const snrDetector = detections.find( detector => detector && detector.detector === "SnrDetector")
            dispatch(updateContextStates({
                snrTriggered: snrDetector && snrDetector.triggered,
                bgNoiseTriggered: backgroundNoiseDetector && backgroundNoiseDetector.triggered,
                detectionEnded: true
            }))
        }
        
    }, [detections])

    // Notify story started and ended.
    const { storyInProgress, storyStarted, storyEnded } = props;
    useEffect(() => {
        dispatch(notifyStoryStarted(storyStarted))
        dispatch(notifyStoryEnded(storyEnded))
    }, [storyInProgress])

    // For logging reader manager events.
    const { earlyReaderMode } = props;
    useReaderManagerLogs({
        currentWord,
        earlyReaderMode,
    });

    return null
}
